/**
 * 个人
 * 2017-12-6
 */
"use strict";
angular.module("personalModule", []).
controller("personalCtrl", ["$scope", '$rootScope', "$stateParams", "localStorageService", "Upload", "modalDialog", "httpService", "$state", "$validation", "$element", 'editPictureService', function($scope, $rootScope, $stateParams, localStorageService, Upload, modalDialog, httpService, $state, $validation, $element, editPictureService) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {};
        $scope.data = {
            listData: [],
            selectedArray: [],
            channelIds: [],
            errorAccount: false, //帐号错误提示
            errorName: false, //姓名错误提示
            signing: false, //签约
            errEmail: false, //邮箱错误
            errimg: false, //图片提示框

        };
        $scope.info = {
            channelIds: ""
        };
        $scope.parentParams = $rootScope.informationRetained;
    }
    /**
     * [initStatus description] 初始化数据
     */
    function initData() {
        accessChannel();
        getPicSizeLimit();
    }
    /**
     * [regularIf description] 判断是否显示正确图标
     * @return {[type]} [description]
     */
    $scope.regularIf = function(key, value) {
        switch (key) {
            case 1: //帐户名称
                $scope.isShowTipsA = false;
                $scope.data.isShowTipsAa = false;
                var uesrLength = $element.find('.table>ul>li:first-child>.tips');
                uesrLength.text().length > 8 ? uesrLength.addClass('notPaddintTop') : uesrLength.removeClass('notPaddintTop');
                break;
            case 2: //真实姓名
                $scope.isShowTipsB = false;
                $scope.data.isShowTipsBb = false;
                var CompteLength = $element.find('.table>ul>li:nth-child(4)>.tips');
                CompteLength.text().length > 10 ? CompteLength.addClass('notPaddintTop') : CompteLength.removeClass('notPaddintTop');
                break;
            case 3: //身份证号
                $scope.isShowTipsC = false;
                $scope.data.isShowTipsCc = false;
                break;
            case 4: //邮箱
                $scope.isShowTipsD = false;
                $scope.data.isShowTipsDd = false;
                $scope.data.errEmail = false;
                break;
            case 5:
                $scope.isShowTipsE = false;
                $scope.data.isShowTipsEe = false;
                break;
        }
        $validation.validate($scope.personal[value]).success(function() {
            var reg = /[\u4E00-\u9FA5]/;
            switch (key) {
                case 1:
                    $scope.data.isShowTipsAa = true;
                    break;
                case 2:
                    $scope.data.isShowTipsBb = true;
                    break;
                case 3:
                    $scope.data.isShowTipsCc = true;
                    break;
                case 4:
                    if (/\S/.test($scope.info.email) && $scope.info.email != undefined) {
                        httpService.http('/mcnww/web/user/existsValid.do', { name: 'email', param: $scope.info.email }, 'post').then(function(data) {
                            if (data.status == 'y') {
                                // errEmail
                                $scope.data.isShowTipsDd = true;
                            } else {
                                $scope.data.errEmail = true;
                            }
                        });
                    } else {
                        $scope.data.isShowTipsDd = true;
                    }
                    break;
                case 5:
                    $scope.data.isShowTipsEe = true;
            }
        });
    };
    /**
     * [codeNum description] 判断多少个数
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    function codeNum(value) {
        var reg = /[\u4E00-\u9FA5]/;
        var quantity = 0;
        for (var i in value) {
            reg.test(value[i]) ? quantity += 2 : quantity += 1;
        }
        return quantity;
    }
    /**
     * [selectDoc description] 单选
     * @param  {[type]} id [description] 分类id
     * @return {[type]}      [description]
     */
    $scope.selectDoc = function(id) {
        var array = $scope.info.channelIds.split(",");
        var index = array.indexOf((id + ""));
        if (index >= 0) {
            array.splice(index, 1);
        } else {
            array.push(id);
        }
        $scope.info.channelIds = array.join(",");
    };
    /**
     * [changeHeadPortrait description]  更换头像
     * @param  {[type]} files    [description]
     * @param  {[type]} file     [description]
     * @param  {[type]} newFiles [description]
     * @return {[type]}          [description]
     */
    $scope.changeHeadPortrait = function(files, file, newFiles) {

        if (file.size > Number($scope.status.picSizeLimit) * 1024) {
            modalDialog.alertType("", "图片最大不能超过" + $scope.status.picSizeLimit + "KB!", "warning", "confirm");
            return;
        }

        var typeData = file.type.split('/')[1];
        if (typeData != 'jpg' && typeData != 'jpeg' && typeData != 'png') {
            modalDialog.success("您只能上传jpg,jpeg,png类型的文件", "success", false, function() {}, function() {}, '', 'getCodeSuccess');
            return;
        }
        // .jpg,.jpeg,.png, 'bmp', 'gif'
        // if(file)
        var imgType = ['jpg', 'jpeg', 'png'],
            fileType = newFiles[0].name.substr(newFiles[0].name.lastIndexOf('.') + 1).toLowerCase();
        if (newFiles) {
            $scope.status.changeHeader = true;
        }
        Upload.upload({
            url: "/mcnww/upload/image.do",
            headers:{requestToken:sessionStorage.getItem('requestToken')},
            data: {
                file: newFiles[0],
            },
        }).then(function(resp) {
            if (resp.data.success == false) {
                modalDialog.success(resp.data.message, "success", false, function() {}, function() {}, '', 'getCodeSuccess');
                return;
            }
            
            editPictureService.newCropperApp(angular.globalConfig.pictureServer + resp.data.url, "100,100").then(function(data) {
                var time = new Date().getTime();
                $scope.info.logo = resp.data.url;
                $scope.headPic = data.imgSrc + '?' + time;
                $scope.data.errimg = false;
            });
        });
    };
    /**
     * [savePwd description]  保存
     * @param  {[type]}   [description]
     */
    $scope.savePwd = function() {
        $validation.validate($scope.personal).success(function() {
            if (!$scope.headPic) {
                $scope.data.errimg = true;
                return;
            }
            if ($scope.data.errEmail) {
                $element.find("[name='email']").focus();
                $element.find("[name='email']").blur();
                return;
            }
            $scope.info.mediaType = $stateParams.type;
            // $scope.info.channelIds = $scope.data.selectedArray + "";
            var params = $.extend($scope.parentParams, $scope.info);
            $rootScope.personalCertification = $scope.info;
            httpService.http("/mcnww/web/user/register.do", params, "post").then(function(data) {
                // modalDialog.alertType("提交成功", "", "success", false, function() {});
                modalDialog.success("提交成功", "success", false, function() {}, function() {}, 'left0');
                $rootScope.informationRetained = '';
                $rootScope.personalCertification = '';
                if(data.success){
                    sessionStorage.setItem("requestToken", data.requestToken);
                }
                $state.go("register.pgcsuccess");
            });
        }).error(function() {
            angular.invalidPosition($scope.personal, $element);
        });
    };
    /**
     * [lastStep description]  上一步
     * @param  {[type]}   [description]
     */
    $scope.lastStep = function() {
        $state.go("register.pgcauthentication", $stateParams);
    };
    /**
     * [accessChannel description] 获取渠道
     * @return {[type]} [description]
     */
    function accessChannel() {
        httpService.http("/mcnww/web/channel/querychannels.do", "", "get").then(function(data) {
            // console.log(data);
            $scope.data.channelIds = data.data;
            var selectedArray = [];
            selectedArray = data.data.map(function(item) {
                return item.id;
            });
            $scope.info.channelIds = selectedArray.join(",");
        });
    };
    /**
     * [getPicSizeLimit description] 获取图片尺寸上限
     * @return {[type]} [description]
     */
    function getPicSizeLimit() {
        httpService.http("/mcnww/web/image/getImageSizelimit.do", "", "get").then(function(data) {
            $scope.status.picSizeLimit = data.message;
        });
    }
}]);